import * as z from "zod";

export const InboundConsolidationLifecycleStatusSchema = z.enum([
  "collecting",
  "preparing",
  "ready_to_ship",
  "fulfilled",
]);
export type InboundConsolidationLifecycleStatus = z.infer<
  typeof InboundConsolidationLifecycleStatusSchema
>;

export const InboundConsolidationDisplayStatuses: readonly InboundConsolidationLifecycleStatus[] =
  [
    InboundConsolidationLifecycleStatusSchema.enum.collecting,
    InboundConsolidationLifecycleStatusSchema.enum.preparing,
    InboundConsolidationLifecycleStatusSchema.enum.ready_to_ship,
    InboundConsolidationLifecycleStatusSchema.enum.fulfilled,
  ];

export const consolidationDbStatusToLifecycle: Record<
  "open" | "closed" | "sealed" | "completed",
  InboundConsolidationLifecycleStatus
> = {
  open: "collecting",
  closed: "preparing",
  sealed: "ready_to_ship",
  completed: "fulfilled",
};

export const lifecycleToConsolidationDbStatuses: Record<
  InboundConsolidationLifecycleStatus,
  "open" | "closed" | "sealed" | "completed"
> = {
  collecting: "open",
  preparing: "closed",
  ready_to_ship: "sealed",
  fulfilled: "completed",
};
